function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "calculating_svg__a",
  x1: "-1.034%",
  x2: "135.725%",
  y1: "49.997%",
  y2: "49.997%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C393"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C393"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  stopColor: "#23C393",
  stopOpacity: 0.47
}), /*#__PURE__*/React.createElement("stop", {
  offset: "84%",
  stopColor: "#23C393",
  stopOpacity: 0.13
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#23C393",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "calculating_svg__b",
  x1: "50.5%",
  x2: "50.5%",
  y1: "-12728.319%",
  y2: "10602.655%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C393"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C393"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  stopColor: "#23C393",
  stopOpacity: 0.47
}), /*#__PURE__*/React.createElement("stop", {
  offset: "84%",
  stopColor: "#23C393",
  stopOpacity: 0.13
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#23C393",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "calculating_svg__c",
  x1: "50.5%",
  x2: "50.5%",
  y1: "-12728.319%",
  y2: "10602.655%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C393"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C393"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  stopColor: "#23C393",
  stopOpacity: 0.47
}), /*#__PURE__*/React.createElement("stop", {
  offset: "84%",
  stopColor: "#23C393",
  stopOpacity: 0.13
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#23C393",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "calculating_svg__d",
  x1: "50.002%",
  x2: "50.002%",
  y1: "-145.982%",
  y2: "119.517%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C393"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C393"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "39.857%",
  stopColor: "#23C393",
  stopOpacity: 0.47
}), /*#__PURE__*/React.createElement("stop", {
  offset: "67.129%",
  stopColor: "#23C393",
  stopOpacity: 0.13
}), /*#__PURE__*/React.createElement("stop", {
  offset: "96.614%",
  stopColor: "#23C393",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "calculating_svg__e",
  x1: "0%",
  x2: "100%",
  y1: "14.238%",
  y2: "14.238%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C393",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#23C393",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "calculating_svg__f",
  x1: "76.394%",
  x2: "-21.321%",
  y1: "112.301%",
  y2: "-54.691%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C393"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C393"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  stopColor: "#23C393",
  stopOpacity: 0.47
}), /*#__PURE__*/React.createElement("stop", {
  offset: "84%",
  stopColor: "#23C393",
  stopOpacity: 0.13
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#23C393",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "calculating_svg__g",
  x1: "0%",
  x2: "100%",
  y1: "18.7%",
  y2: "18.7%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C393",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#23C393",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "calculating_svg__h",
  x1: "0%",
  x2: "100%",
  y1: "24.269%",
  y2: "24.269%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C393",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#23C393",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "calculating_svg__i",
  x1: "18.031%",
  x2: "76.832%",
  y1: "32.116%",
  y2: "65.18%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C393"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#23C393"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  stopColor: "#23C393",
  stopOpacity: 0.47
}), /*#__PURE__*/React.createElement("stop", {
  offset: "84%",
  stopColor: "#23C393",
  stopOpacity: 0.13
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#23C393",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "calculating_svg__j",
  x1: "39.109%",
  x2: "57.94%",
  y1: "20.964%",
  y2: "71.273%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "calculating_svg__k",
  x1: "312.967%",
  x2: "293.01%",
  y1: "24.84%",
  y2: "68.441%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "calculating_svg__l",
  x1: "101.092%",
  x2: "-1.11%",
  y1: "49.991%",
  y2: "49.991%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "10%",
  stopColor: "#FFF",
  stopOpacity: 0.98
}), /*#__PURE__*/React.createElement("stop", {
  offset: "23%",
  stopColor: "#FFF",
  stopOpacity: 0.92
}), /*#__PURE__*/React.createElement("stop", {
  offset: "36%",
  stopColor: "#FFF",
  stopOpacity: 0.83
}), /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  stopColor: "#FFF",
  stopOpacity: 0.69
}), /*#__PURE__*/React.createElement("stop", {
  offset: "65%",
  stopColor: "#FFF",
  stopOpacity: 0.52
}), /*#__PURE__*/React.createElement("stop", {
  offset: "81%",
  stopColor: "#FFF",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: "97%",
  stopColor: "#FFF",
  stopOpacity: 0.06
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "calculating_svg__m",
  x1: "101.092%",
  x2: "-1.11%",
  y1: "49.992%",
  y2: "49.992%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#FFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "10%",
  stopColor: "#FFF",
  stopOpacity: 0.98
}), /*#__PURE__*/React.createElement("stop", {
  offset: "23%",
  stopColor: "#FFF",
  stopOpacity: 0.92
}), /*#__PURE__*/React.createElement("stop", {
  offset: "36%",
  stopColor: "#FFF",
  stopOpacity: 0.83
}), /*#__PURE__*/React.createElement("stop", {
  offset: "50%",
  stopColor: "#FFF",
  stopOpacity: 0.69
}), /*#__PURE__*/React.createElement("stop", {
  offset: "65%",
  stopColor: "#FFF",
  stopOpacity: 0.52
}), /*#__PURE__*/React.createElement("stop", {
  offset: "81%",
  stopColor: "#FFF",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: "97%",
  stopColor: "#FFF",
  stopOpacity: 0.06
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#FFF",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "calculating_svg__o",
  x1: "61.601%",
  x2: "-7.478%",
  y1: "37.662%",
  y2: "162.061%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#878EC1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#313866"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "calculating_svg__r",
  x1: "99.999%",
  x2: ".001%",
  y1: "50%",
  y2: "50%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#878EC1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#313866"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "calculating_svg__u",
  x1: "47.137%",
  x2: "56.891%",
  y1: "2.928%",
  y2: "104.207%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#878EC1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#313866"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "calculating_svg__x",
  x1: "70.058%",
  x2: "50.578%",
  y1: "75.762%",
  y2: "37.692%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#878EC1"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#313866"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "calculating_svg__A",
  x1: "95.156%",
  x2: "5.779%",
  y1: "44.286%",
  y2: "53.536%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#313866"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#313866"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "calculating_svg__D",
  x1: "348.098%",
  x2: "-91.445%",
  y1: "-.439%",
  y2: "76.478%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#313866"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#313866"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "calculating_svg__G",
  x1: "347.06%",
  x2: "-219.24%",
  y1: "-7.374%",
  y2: "99.868%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#313866"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#313866"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "calculating_svg__J",
  x1: "138.408%",
  x2: "-171.567%",
  y1: "33.472%",
  y2: "84.804%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#313866"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#313866"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "calculating_svg__M",
  x1: "44.358%",
  x2: "60.65%",
  y1: "99.841%",
  y2: "2.055%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#313866"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#313866"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "calculating_svg__P",
  x1: "83.014%",
  x2: "1.986%",
  y1: "31.551%",
  y2: "76.189%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#313866"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#313866"
})), /*#__PURE__*/React.createElement("path", {
  id: "calculating_svg__n",
  d: "M28.726.767v52.176L2.418 31.79.479 9.693z"
}), /*#__PURE__*/React.createElement("path", {
  id: "calculating_svg__q",
  d: "M4.312 10.211C-7.636 22.159 14.767 42.074 14.767 42.074l-9.956 5.973 7.467.499-1.991 5.476 7.467-1.494L16.26 59s9.958-2.987 13.443-9.957c3.485-6.969-5.227-21.781-5.227-21.781l3.762-2.862.079-24.146s-.084-.002-.245-.002c-1.879 0-14.178.377-23.76 9.959"
}), /*#__PURE__*/React.createElement("path", {
  id: "calculating_svg__t",
  d: "M6.329 1.903c-17.713 4.964 13.248 52.364 22.687 53.476 9.437 1.114 13.11-24.708 13.11-24.708l7.626 8.14.648-9.919 7.53 2.025-4.575-8.592 7.082.598s-7.346-12.426-14.944-10.669c-7.597 1.757-16.76 17.031-16.76 17.031S30.906.956 12.596.959c-1.867 0-3.95.295-6.267.944"
}), /*#__PURE__*/React.createElement("path", {
  id: "calculating_svg__w",
  d: "M102.259.081a1.466 1.466 0 00-.699.504c-6.542 8.572-12.909 11.744-17.121 13.842-2.082 1.037-3.726 1.856-4.839 2.999l-.011.012a9.459 9.459 0 00-2.14 3.59C71.1 17.09 63.091 16.739 53.598 19.99l-1.927.659c-9.493 3.253-15.607 8.441-18.207 15.443a9.466 9.466 0 00-3.892-1.524l-.018-.002c-1.579-.221-3.381.14-5.663.598-4.615.925-11.586 2.324-22.005-.438a1.48 1.48 0 00-.829.008h-.001l-.001.001-.051.016-.008.003a1.484 1.484 0 00-.915 1.883c.076.222.199.415.355.571.419.443 2.108 2.423 2.562 2.957 1.848 2.172 6.933 6.007 10.319 11.704l4.227-1.494-3.333 3.305c.004.014 3.247-.594 3.247-.594l-2.281 2.305a20.148 20.148 0 003.729 5.009l5.679-3.538-3.358 5.653c2.13 1.7 4.769 2.728 7.571 2.953l1.153-2.589 1.143 2.352 1.613-4.705.876 4.393a19.868 19.868 0 003.201-1.272c.216 1.457.529 2.9.941 4.31.014.045.029.088.046.131.644 1.624 1.885 3.941 5.219 5.312 3.421 1.406 8.329 1.547 15.003.431a4.085 4.085 0 013.195 1.31c.342.432 1.033.866 2.422.891 1.651.029 4.142-.502 7.404-1.58a.075.075 0 00.016-.005l.227-.078a.084.084 0 00.02-.008c5.581-2.002 8.198-3.757 8.182-5.493a4.081 4.081 0 011.72-2.977c5.665-3.052 9.355-6.023 11.283-9.081.924-1.463 2.067-3.805 1.347-7.225-.274-1.321-.975-2.88-2.127-4.728 3.327-.686 6.069-2.058 7.865-3.715l-3.239-3.693 5.577.777a18.064 18.064 0 002.241-9.056l-4.066-1.341 3.876-2.005c-.11-.853-.26-1.685-.407-2.394-1.614-7.342.389-14.651.511-17.85.03-.736.125-3.37.178-3.961a1.484 1.484 0 00-.94-1.518 1.48 1.48 0 00-1.019-.02"
}), /*#__PURE__*/React.createElement("path", {
  id: "calculating_svg__z",
  d: "M2.998 3.165c1.848 2.172 6.933 6.007 10.319 11.704l4.227-1.494-3.333 3.305c.004.014 3.247-.594 3.247-.594l-2.281 2.305a20.148 20.148 0 003.729 5.009l5.679-3.538-3.358 5.653c2.13 1.7 4.769 2.728 7.571 2.953l1.153-2.589 1.143 2.352 1.613-4.705.876 4.393c.908-.272 1.801-.726 3.174-1.386a29.193 29.193 0 01-.179-1.722c-.481-5.118-.882-10.922-3.283-14.532-2.35-3.527-7.488-4.314-13.774-4.718C13.198 5.155 6.829 4.851.436.208c.419.443 2.108 2.423 2.562 2.957"
}), /*#__PURE__*/React.createElement("path", {
  id: "calculating_svg__C",
  d: "M1.417 2.036C.636 2.432.299 3.228.874 3.482c1.31.351 2.707.15 3.864-.56C6.324 2.004 6.614.935 5.671.678a.908.908 0 00-.246-.029c-1.166 0-4.008 1.387-4.008 1.387"
}), /*#__PURE__*/React.createElement("path", {
  id: "calculating_svg__F",
  d: "M1.059.861c-1.923.765-.186 2.355 1.062 2.187 1.249-.166 2.844-1.393 2.354-2.043C4.226.674 3.602.539 2.918.539c-.658 0-1.372.125-1.859.322"
}), /*#__PURE__*/React.createElement("path", {
  id: "calculating_svg__I",
  d: "M2.897 1.148C1.426 1.468.195 3.601.299 4.283c.124.852 1.238.852 3.798.365 2.558-.486 4.379-2.417 4.15-3.086-.144-.42-1.632-.613-3.084-.613-.865 0-1.718.068-2.266.199"
}), /*#__PURE__*/React.createElement("path", {
  id: "calculating_svg__L",
  d: "M12.729 12.81c-2.649 3.056-5.5 4.951-6.518 5.759l-.096.08C.53 23.199.582 26.468.402 28.807c-.327 4.237 3.53 9.679 6.325 13.659.307.435.624.905.936 1.391 4.283-.934 6.214-2.175 7.884-3.715l-3.239-3.693 5.577.777a18.064 18.064 0 002.241-9.056l-4.066-1.341 3.876-2.005c-.11-.853-.26-1.685-.407-2.394-1.614-7.342.389-14.651.511-17.85.03-.736.125-3.37.178-3.961 0 0-2.162 6.046-7.489 12.191"
}), /*#__PURE__*/React.createElement("path", {
  id: "calculating_svg__O",
  d: "M33.397 5.78c-.484.17-1.006.353-1.589.494-4.498 1.271-6.639 1.31-11.42 2.986-4.781 1.676-6.482 2.971-10.79 4.802-.546.233-1.06.435-1.551.606-4.085 1.433-6.024.717-6.972-1.412-2.389 3.927 3.349 6.352 7.149 6.833l.006.012c3.882.494 8.402-.156 14.486-2.073l1.316-.461c5.955-2.284 9.885-4.617 12.603-7.426 2.718-2.807 5.634-8.252 1.332-9.819.589 2.275-.484 4.026-4.57 5.458"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#calculating_svg__a)",
  fillRule: "nonzero",
  d: "M36.14 236.108l134.14 77.45a17 17 0 0017 0l134.13-77.45a7.48 7.48 0 000-13l-134.11-77.4a17 17 0 00-17 0l-134.16 77.44a7.48 7.48 0 000 12.96z",
  transform: "translate(0 1.072)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#calculating_svg__b)",
  fillRule: "nonzero",
  d: "M325.17 228.498h-.09c.06.373.09.751.09 1.13v-1.13z",
  transform: "translate(0 1.072)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#calculating_svg__c)",
  fillRule: "nonzero",
  d: "M32.4 228.498v1.13a8.47 8.47 0 01.09-1.13h-.09z",
  transform: "translate(0 1.072)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#calculating_svg__d)",
  fillRule: "nonzero",
  d: "M187.3 313.558a17 17 0 01-17 0l-134.16-77.45a7.423 7.423 0 01-3.74-6.48v189.3h292.77v-189.3a7.402 7.402 0 01-3.74 6.48l-134.13 77.45z",
  transform: "translate(0 1.072)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#9FEED9",
  fillRule: "nonzero",
  d: "M280.4 231.55l-89.83 52.71a23.85 23.85 0 01-24.16 0l-89.83-52.71a9.52 9.52 0 01-4.7-8.15l-.22-113 213.66-.52-.23 113.57a9.51 9.51 0 01-4.69 8.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#calculating_svg__e)",
  fillRule: "nonzero",
  d: "M280.4 230.478l-89.83 52.71a23.85 23.85 0 01-24.16 0l-89.83-52.71a9.52 9.52 0 01-4.7-8.15l-.22-113 213.66-.52-.23 113.57a9.51 9.51 0 01-4.69 8.1z",
  transform: "translate(0 1.072)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#192F28",
  fillRule: "nonzero",
  d: "M85.63 147.65l19.38 11.12-10.51 6.1a3 3 0 00-1.5 2.59v5.7a3.35 3.35 0 001.64 2.87l13.82 8.11-14 8.05a3 3 0 00-1.5 2.6v5.7a3.35 3.35 0 001.64 2.87L162.07 243l-.06 10a2.44 2.44 0 01-3.66 2.1l-71.52-41.28a7.09 7.09 0 01-3.53-6.12V149a1.55 1.55 0 012.33-1.35z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#calculating_svg__f)",
  fillRule: "nonzero",
  d: "M85.63 146.578l19.38 11.12-10.51 6.1a3 3 0 00-1.5 2.59v5.7a3.35 3.35 0 001.64 2.87l13.82 8.11-14 8.05a3 3 0 00-1.5 2.6v5.7a3.35 3.35 0 001.64 2.87l67.47 39.64-.06 10a2.44 2.44 0 01-3.66 2.1l-71.52-41.28a7.09 7.09 0 01-3.53-6.12v-58.7a1.55 1.55 0 012.33-1.35z",
  transform: "translate(0 1.072)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M94.43 197.38l67.67 39.7v5.87l-67.48-39.59a3.35 3.35 0 01-1.64-2.87v-5.7a3 3 0 001.45 2.59zm13.98-13.25L94.59 176a3.35 3.35 0 01-1.64-2.87v-5.7a3 3 0 001.48 2.59l19 11.17 1.67 1 47.12 27.64v5.87l-52.18-30.62-1.63-.95z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M94.5 192.19l14-8.06 1.63 1 52.18 30.62-.12 21.37-67.67-39.7a3 3 0 010-5.19l-.02-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#calculating_svg__g)",
  fillRule: "nonzero",
  d: "M94.5 191.118l14-8.06 1.63 1 52.18 30.62-.12 21.37-67.67-39.7a3 3 0 010-5.19l-.02-.04z",
  transform: "translate(0 1.072)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M113.5 181.22l-19-11.17a3 3 0 010-5.18l10.56-6.1 1.62.93 22.12 12.69 1.82 1.05 27.77 15.93a8.001 8.001 0 014 6.93l-.08 13.54-47.18-27.64-1.63-.98z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#calculating_svg__h)",
  fillRule: "nonzero",
  d: "M113.5 180.148l-19-11.17a3 3 0 010-5.18l10.56-6.1 1.62.93 22.12 12.69 1.82 1.05 27.77 15.93a8.001 8.001 0 014 6.93l-.08 13.54-47.18-27.64-1.63-.98z",
  transform: "translate(0 1.072)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#9FEED9",
  fillRule: "nonzero",
  d: "M281.77 115.19l-91.1 53.46a24.08 24.08 0 01-24.36 0l-91.1-53.46a7.3 7.3 0 010-12.63L166.5 49.9a24 24 0 0124.06 0l91.21 52.66a7.3 7.3 0 010 12.63z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#calculating_svg__i)",
  fillRule: "nonzero",
  d: "M354.72 49.418l-.58 115.73c0 2.74-3 7.87-5.33 9.24l-131.62 76.82a2.42 2.42 0 01-3.65-2.09v-117.19a4.88 4.88 0 012.41-4.22l136-79.86c1.73-1.01 2.78-.4 2.77 1.57z",
  transform: "translate(0 1.072)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#calculating_svg__j)",
  fillRule: "nonzero",
  d: "M226.62 200.388v31.36l113.65-64.7-.1-94-17.26 38.88a9 9 0 01-9.39 5.3l-6.92-.86a9 9 0 00-9.55 5.7l-14.34 37a9.06 9.06 0 01-3.73 4.46l-48 29.2a9 9 0 00-4.36 7.66z",
  transform: "translate(0 1.072)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#calculating_svg__k)",
  fillRule: "nonzero",
  d: "M226.62 215.138v16.61l113.65-64.7-.1-65.09-15.67 35.38a14.19 14.19 0 01-14.74 8.32 14.21 14.21 0 00-14.55 7.92l-11.79 24.35a14.22 14.22 0 01-5.41 6l-51.39 31.21z",
  transform: "translate(0 1.072)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#calculating_svg__l)",
  strokeLinecap: "round",
  strokeWidth: 2.5,
  d: "M340.17 101.928l-15.67 35.41a14.19 14.19 0 01-14.74 8.32h0a14.21 14.21 0 00-14.55 7.92l-11.79 24.35a14.22 14.22 0 01-5.41 6l-51.39 31.26",
  transform: "translate(0 1.072)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "url(#calculating_svg__m)",
  strokeLinecap: "round",
  strokeWidth: 2.5,
  d: "M340.17 73.018l-17.26 38.91a9 9 0 01-9.39 5.3l-6.89-.86a9 9 0 00-9.56 5.72l-14.36 37.34a9.12 9.12 0 01-3.74 4.48l-52.35 31.83",
  transform: "translate(0 1.072)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 89)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(43 57)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "calculating_svg__p",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calculating_svg__n"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#calculating_svg__o)",
  mask: "url(#calculating_svg__p)",
  d: "M28.726.767v52.176L2.418 31.79.479 9.693z"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(44 101)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "calculating_svg__s",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calculating_svg__q"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#calculating_svg__r)",
  d: "M4.312 10.211C-7.636 22.159 14.767 42.074 14.767 42.074l-9.956 5.973 7.467.499-1.991 5.476 7.467-1.494L16.26 59s9.958-2.987 13.443-9.957c3.485-6.969-5.227-21.781-5.227-21.781l3.762-2.862.079-24.146s-.084-.002-.245-.002c-1.879 0-14.178.377-23.76 9.959",
  mask: "url(#calculating_svg__s)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(38 65)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "calculating_svg__v",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calculating_svg__t"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#calculating_svg__u)",
  d: "M6.329 1.903c-17.713 4.964 13.248 52.364 22.687 53.476 9.437 1.114 13.11-24.708 13.11-24.708l7.626 8.14.648-9.919 7.53 2.025-4.575-8.592 7.082.598s-7.346-12.426-14.944-10.669c-7.597 1.757-16.76 17.031-16.76 17.031S30.906.956 12.596.959c-1.867 0-3.95.295-6.267.944",
  mask: "url(#calculating_svg__v)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#221F34",
  d: "M.996 34.754l.009-.003a.73.73 0 01.05-.016h.003c.279-.085.565-.084.829-.009 10.418 2.761 17.389 1.363 22.005.437 2.28-.457 4.083-.818 5.663-.597l.017.001a9.481 9.481 0 013.892 1.525c2.6-7.002 8.714-12.19 18.207-15.442l1.927-.66c9.493-3.252 17.502-2.9 23.85 1.038a9.459 9.459 0 012.152-3.603c1.113-1.143 2.757-1.962 4.839-2.998 4.212-2.099 10.578-5.27 17.12-13.843a1.484 1.484 0 012.66 1.034c-.054.592-.15 3.226-.18 3.961-.121 3.2-2.124 10.51-.51 17.85.148.71.297 1.542.406 2.394l-3.875 2.005 4.066 1.341a18.075 18.075 0 01-2.24 9.057l-5.577-.778 3.239 3.694c-1.797 1.657-4.538 3.03-7.865 3.715 1.15 1.848 1.852 3.407 2.126 4.728.72 3.42-.423 5.762-1.346 7.225-1.93 3.057-5.62 6.028-11.283 9.081a4.077 4.077 0 00-1.721 2.976c.016 1.737-2.601 3.491-8.182 5.494l-.02.008-.227.077-.015.006c-3.263 1.077-5.754 1.61-7.405 1.58-1.39-.026-2.08-.46-2.422-.89a4.082 4.082 0 00-3.195-1.31c-6.674 1.115-11.582.974-15.003-.432-3.334-1.372-4.575-3.688-5.22-5.312a1.84 1.84 0 01-.045-.13 32.264 32.264 0 01-.941-4.31 19.96 19.96 0 01-3.201 1.271l-.876-4.394-1.612 4.706-1.144-2.352-1.152 2.59c-2.803-.226-5.442-1.254-7.573-2.954l3.36-5.654-5.68 3.54a20.184 20.184 0 01-3.73-5.01l2.282-2.305s-3.242.607-3.247.594l3.333-3.306-4.227 1.494c-3.386-5.697-8.471-9.532-10.32-11.703-.452-.534-2.142-2.514-2.561-2.958a1.484 1.484 0 01.56-2.453"
}), /*#__PURE__*/React.createElement("mask", {
  id: "calculating_svg__y",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calculating_svg__w"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#calculating_svg__x)",
  d: "M102.259.081a1.466 1.466 0 00-.699.504c-6.542 8.572-12.909 11.744-17.121 13.842-2.082 1.037-3.726 1.856-4.839 2.999l-.011.012a9.459 9.459 0 00-2.14 3.59C71.1 17.09 63.091 16.739 53.598 19.99l-1.927.659c-9.493 3.253-15.607 8.441-18.207 15.443a9.466 9.466 0 00-3.892-1.524l-.018-.002c-1.579-.221-3.381.14-5.663.598-4.615.925-11.586 2.324-22.005-.438a1.48 1.48 0 00-.829.008h-.001l-.001.001-.051.016-.008.003a1.484 1.484 0 00-.915 1.883c.076.222.199.415.355.571.419.443 2.108 2.423 2.562 2.957 1.848 2.172 6.933 6.007 10.319 11.704l4.227-1.494-3.333 3.305c.004.014 3.247-.594 3.247-.594l-2.281 2.305a20.148 20.148 0 003.729 5.009l5.679-3.538-3.358 5.653c2.13 1.7 4.769 2.728 7.571 2.953l1.153-2.589 1.143 2.352 1.613-4.705.876 4.393a19.868 19.868 0 003.201-1.272c.216 1.457.529 2.9.941 4.31.014.045.029.088.046.131.644 1.624 1.885 3.941 5.219 5.312 3.421 1.406 8.329 1.547 15.003.431a4.085 4.085 0 013.195 1.31c.342.432 1.033.866 2.422.891 1.651.029 4.142-.502 7.404-1.58a.075.075 0 00.016-.005l.227-.078a.084.084 0 00.02-.008c5.581-2.002 8.198-3.757 8.182-5.493a4.081 4.081 0 011.72-2.977c5.665-3.052 9.355-6.023 11.283-9.081.924-1.463 2.067-3.805 1.347-7.225-.274-1.321-.975-2.88-2.127-4.728 3.327-.686 6.069-2.058 7.865-3.715l-3.239-3.693 5.577.777a18.064 18.064 0 002.241-9.056l-4.066-1.341 3.876-2.005c-.11-.853-.26-1.685-.407-2.394-1.614-7.342.389-14.651.511-17.85.03-.736.125-3.37.178-3.961a1.484 1.484 0 00-.94-1.518 1.48 1.48 0 00-1.019-.02",
  mask: "url(#calculating_svg__y)"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 37)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "calculating_svg__B",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calculating_svg__z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#calculating_svg__A)",
  d: "M2.998 3.165c1.848 2.172 6.933 6.007 10.319 11.704l4.227-1.494-3.333 3.305c.004.014 3.247-.594 3.247-.594l-2.281 2.305a20.148 20.148 0 003.729 5.009l5.679-3.538-3.358 5.653c2.13 1.7 4.769 2.728 7.571 2.953l1.153-2.589 1.143 2.352 1.613-4.705.876 4.393c.908-.272 1.801-.726 3.174-1.386a29.193 29.193 0 01-.179-1.722c-.481-5.118-.882-10.922-3.283-14.532-2.35-3.527-7.488-4.314-13.774-4.718C13.198 5.155 6.829 4.851.436.208c.419.443 2.108 2.423 2.562 2.957",
  mask: "url(#calculating_svg__B)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(46 25)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "calculating_svg__E",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calculating_svg__C"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#calculating_svg__D)",
  d: "M1.417 2.036C.636 2.432.299 3.228.874 3.482c1.31.351 2.707.15 3.864-.56C6.324 2.004 6.614.935 5.671.678a.908.908 0 00-.246-.029c-1.166 0-4.008 1.387-4.008 1.387",
  mask: "url(#calculating_svg__E)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(52 28)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "calculating_svg__H",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calculating_svg__F"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#calculating_svg__G)",
  d: "M1.059.861c-1.923.765-.186 2.355 1.062 2.187 1.249-.166 2.844-1.393 2.354-2.043C4.226.674 3.602.539 2.918.539c-.658 0-1.372.125-1.859.322",
  mask: "url(#calculating_svg__H)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(55 22)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "calculating_svg__K",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calculating_svg__I"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#calculating_svg__J)",
  d: "M2.897 1.148C1.426 1.468.195 3.601.299 4.283c.124.852 1.238.852 3.798.365 2.558-.486 4.379-2.417 4.15-3.086-.144-.42-1.632-.613-3.084-.613-.865 0-1.718.068-2.266.199",
  mask: "url(#calculating_svg__K)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(84 1)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "calculating_svg__N",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calculating_svg__L"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#calculating_svg__M)",
  d: "M12.729 12.81c-2.649 3.056-5.5 4.951-6.518 5.759l-.096.08C.53 23.199.582 26.468.402 28.807c-.327 4.237 3.53 9.679 6.325 13.659.307.435.624.905.936 1.391 4.283-.934 6.214-2.175 7.884-3.715l-3.239-3.693 5.577.777a18.064 18.064 0 002.241-9.056l-4.066-1.341 3.876-2.005c-.11-.853-.26-1.685-.407-2.394-1.614-7.342.389-14.651.511-17.85.03-.736.125-3.37.178-3.961 0 0-2.162 6.046-7.489 12.191",
  mask: "url(#calculating_svg__N)"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(45 46)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "calculating_svg__Q",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#calculating_svg__O"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#calculating_svg__P)",
  d: "M33.397 5.78c-.484.17-1.006.353-1.589.494-4.498 1.271-6.639 1.31-11.42 2.986-4.781 1.676-6.482 2.971-10.79 4.802-.546.233-1.06.435-1.551.606-4.085 1.433-6.024.717-6.972-1.412-2.389 3.927 3.349 6.352 7.149 6.833l.006.012c3.882.494 8.402-.156 14.486-2.073l1.316-.461c5.955-2.284 9.885-4.617 12.603-7.426 2.718-2.807 5.634-8.252 1.332-9.819.589 2.275-.484 4.026-4.57 5.458",
  mask: "url(#calculating_svg__Q)"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M83.12 52.818c.709-1.2 1.722-3.25.946-4.642a.104.104 0 00-.193.03c-.293 1.438-1.418 2.51-2.651 3.23a.104.104 0 00-.008.177l1.756 1.237c.049.035.119.02.15-.032m-1.883 2.529c.457-.494.895-1.039 1.286-1.602a.156.156 0 00-.038-.216l-1.899-1.346c-.077-.054-.18.012-.162.103l.543 2.983c.032.169.153.205.27.078m-1.027.416l-.576-3.156a.313.313 0 00-.42-.236c-.183.07-.363.135-.541.197-.485.171-1.035.363-1.653.514l-.133.037a.314.314 0 00-.09.562l3.253 2.187a.103.103 0 00.16-.105m-4.41 3.752c1.358-.782 2.546-1.592 3.583-2.44a.418.418 0 00-.03-.67 886.332 886.332 0 01-3.825-2.588.105.105 0 00-.164.083l-.188 5.237a.417.417 0 00.624.378m-1.45.358l.17-5.604a.417.417 0 00-.512-.419c-.568.13-1.109.25-1.643.365-.968.211-1.91.416-2.94.682a.314.314 0 00-.134.534l4.884 4.515a.104.104 0 00.175-.073m-4.92 2.642a57.332 57.332 0 003.674-1.59.416.416 0 00.105-.681l-4.214-3.942a.103.103 0 00-.175.076l.04 5.751a.418.418 0 00.57.386m-1.587.046a.105.105 0 00.187-.065l-.047-6.64a.419.419 0 00-.54-.396 53.754 53.754 0 00-3.536 1.24.417.417 0 00-.173.646l4.109 5.215zm-4.914 1.932a57.404 57.404 0 003.86-1.052.417.417 0 00.206-.657l-3.56-4.517a.105.105 0 00-.185.049l-.83 5.71a.418.418 0 00.509.467m-1.449-.095l.995-6.577a.313.313 0 00-.437-.332c-.972.435-1.835.862-2.723 1.302-.527.26-1.063.526-1.633.799a.313.313 0 00-.103.485l3.718 4.376a.105.105 0 00.183-.053m-5.86 1.009c1.34.015 2.772-.095 4.32-.332a.417.417 0 00.253-.685l-3.418-3.972a.103.103 0 00-.178.037c-.215.709-1.021 3.287-1.372 4.41a.418.418 0 00.395.542m-2.986-3.333l1.52 2.825c.044.08.165.07.192-.017l1.175-3.741a.313.313 0 00-.421-.382l-.127.053c-.577.269-1.127.46-1.612.632-.178.062-.36.123-.546.183a.313.313 0 00-.181.447m-1.546 2.693c.657.194 1.339.348 2.005.448.17.026.243-.078.16-.229l-1.436-2.669a.104.104 0 00-.192.02l-.642 2.237a.154.154 0 00.105.193m-1.855-.668c.25.115.51.225.78.327.056.022.12-.01.136-.068l.602-2.071a.104.104 0 00-.117-.131c-.93.137-1.74.122-2.444-.046a3.951 3.951 0 01-1.645-.816.104.104 0 00-.169.099c.031.173.087.343.168.511.385.799 1.316 1.559 2.69 2.195"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#313866",
  d: "M79.735 32.275c-3.26 1.03-6.022 6.08-11.31 10.654-1.927 1.664-4.098 3.218-4.41 3.442-.314.224 2.272-.496 3.783-.838a7.606 7.606 0 007.791 1.279c4.292-1.507 5.418-4.896 4.955-7.844a8.426 8.426 0 00-.698-2.358s-1.972.398-5.674 2.727c2.062-2.12 3.824-3.791 5.653-4.506a10.028 10.028 0 013.415-.66s-1.535-2.54-3.505-1.896M40.056 48.817l.005.015c1.87-.576 4.31-.387 7.223-.015-4.337.495-6.134 1.42-6.134 1.42.203.798.518 1.564.937 2.273 1.473 2.593 4.48 4.533 8.771 3.026a7.617 7.617 0 005.281-5.87c1.394-.676 3.87-1.733 3.48-1.71-.394.023-3.045.163-5.598.07-7.007-.256-12.29-2.481-15.487-1.245-1.926.74-1.522 3.66-1.522 3.66a9.996 9.996 0 013.044-1.624"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3EB883",
  d: "M47.306 48.832c-4.328.491-6.12 1.414-6.12 1.414a8.66 8.66 0 00.937 2.274c1.473 2.595 4.474 4.538 8.755 3.035a7.598 7.598 0 005.265-5.866c-2.956.051-6.108-.352-8.837-.857m20.49-3.274a7.595 7.595 0 007.775 1.286c4.283-1.503 5.41-4.895 4.938-7.84a8.7 8.7 0 00-.691-2.362s-1.975.4-5.66 2.722c-1.815 2.1-4.023 4.385-6.362 6.194"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#7DC9A9",
  d: "M70.68 45.545c-.642-1.14 5.416-5.112 5.416-5.112 1.836-1.516 2.17-.109 2.023.704-.144.813-.514 3.663-2.45 4.67-1.907.992-4.548.521-4.989-.262m-25.582 7.227c.596.57 2.666 2.384 4.831 2.113 2.166-.27 3.917-2.028 3.731-3.323-.186-1.295-7.423-.604-7.423-.604-1.014.05-2.64.375-1.139 1.814"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  d: "M72.628 43.12s-1.97 1.29-1.676 2.276c.292.985 2.77-2.225 3.466-2.85.695-.625-.19-.696-1.79.574m-21.963 7.752s2.343-.225 2.73.728c.389.952-3.552-.004-4.486-.057-.933-.054-.286-.662 1.756-.67"
})), /*#__PURE__*/React.createElement("path", {
  stroke: "#23C393",
  d: "M32.4 86.14v142.45a9.878 9.878 0 004.95 8.56l134.21 77.49a14.46 14.46 0 0014.45 0l134.22-77.49a9.87 9.87 0 004.94-8.56V86.14"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#23C393",
  d: "M36.14 93.76l134.14 77.44a17 17 0 0017 0l134.13-77.44a7.49 7.49 0 000-13L187.3 3.35a17 17 0 00-17 0L36.14 80.79a7.49 7.49 0 000 12.97z"
}));

function SvgCalculating(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 355,
    height: 420
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/calculating.622db055.svg";
export { SvgCalculating as ReactComponent };